import React from 'react';

import './FormStyles.css';

import { InputBase } from './Input';

class TextArea extends InputBase {
  render() {
    let attributes = this.attributes;
    const { className } = attributes;

    attributes = {
      ...attributes,

      className: `text-5 form-input ${className}`,
    };

    return (
      <textarea {...attributes} />
    );
  }
}

export default TextArea;
